import { L64 } from "@adfenix/alexandria";
import styled from "styled-components";

const Separator = styled.div`
  border-top: 1px solid ${({ theme }) => L64(theme.colors.grey)};
`;

export default Separator;
